import React from 'react';
import '../_styles/AxssComponents.css'
import './styles/GhostTxt.css'

class GhostTxt extends React.Component {
    render(){
        const {
            text,
            color = 'black',
            className
        } = this.props;
        return(
            <div className={`axss-custom-tag ghost-txt ${className}`} style={{color:color}}>{text}</div>
        )
    }
}
export default GhostTxt;